import { SelectLayout } from '@/components/SelectLayout';
import { Text } from '@/components/Text';
import SquareGrid from '@/components/Util/reactSquareGrid';
import { ReactNode } from 'react';
import { View } from 'react-native';
import { styles } from './styles';
import { styles as mainStyles } from './main.styles';
import { Icon } from '@/components/Icon';

interface HomeMainProps {
  exerciseSets: unknown;
  rightButtons: ReactNode;
  licenseStatus?: string | ReactNode | null;
}

export const HomeMain = ({
  exerciseSets,
  rightButtons,
  licenseStatus,
}: HomeMainProps) => {
  return (
    <View style={mainStyles.container}>
      {licenseStatus ? (
        <View style={styles.licenseBanner}>
          <Icon name="alertTriangle" size={18} style={{ lineHeight: 24 }} />
          <Text style={{ fontSize: 18, maxWidth: '90%' }}>{licenseStatus}</Text>
        </View>
      ) : null}
      <SelectLayout
        leftGrid={<SquareGrid items={exerciseSets} rows={2} columns={2} />}
        rightGrid={rightButtons}
      />
    </View>
  );
};
